import { render, staticRenderFns } from "./ordonnance_add_direct.vue?vue&type=template&id=93acfa10&scoped=true&"
import script from "./ordonnance_add_direct.vue?vue&type=script&lang=js&"
export * from "./ordonnance_add_direct.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance_add_direct.vue?vue&type=style&index=0&id=93acfa10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93acfa10",
  null
  
)

export default component.exports